<span class="st-ro-duplicate-slug-dialog__header">{{ title() }}</span>
<div class="st-ro-duplicate-slug-dialog-body">
    <span class="st-ro-duplicate-slug-dialog-body__title">{{ storyTitle() }}</span>
    <div class="st-ro-duplicate-slug-dialog-body-options">
        <span class="st-ro-duplicate-slug-dialog-body__option">{{ optionOneDesc() }}</span>
        <div class="st-ro-duplicate-slug-dialog-body-option-one">
            <span class="st-ro-duplicate-slug-dialog-body-option-one__label">{{ inputLabel() }}</span>
            <st-text-field
                cdkInitialFocus
                class="st-ro-duplicate-slug-dialog-body-option-one__input"
                [placeholder]="placeholder()"
                [value]="value()"
                (changed)="value.set($event)" />
        </div>
        <span class="st-ro-duplicate-slug-dialog-body__option">{{ optionTwoDesc() }}</span>
    </div>
</div>
<div class="st-ro-duplicate-slug-dialog-footer">
    <div class="st-ro-duplicate-slug-dialog-footer-buttons">
        <button
            mat-button
            class="st-ro-duplicate-slug-dialog-footer-buttons__cancel"
            [mat-dialog-close]="undefined">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>
        <button
            mat-button
            [mat-dialog-close]="{
                status: ModalResponseCodes.OK,
            }">
            {{ languageSettings.PSTWebReplaceLabel }}
        </button>
        <button
            mat-button
            [mat-dialog-close]="{
                status: ModalResponseCodes.CUSTOM,
                data: { Title: value()?.trim() },
            }"
            [disabled]="!isTitleValid()">
            {{ languageSettings.PSTWebPlusButtonLabel }}
        </button>
    </div>
</div>
